/**
 * Runs `action` once the next frame has been drawn: the first animation frame comes before that paint, the second
 * after it. For work that must not stand between a click and the card on screen, such as scrolling to it
 * (docs/58). Returns a cancel, for an effect's clean-up.
 */
export function afterFirstFrame(action: () => void): () => void {
  let second = 0;
  const first = requestAnimationFrame(() => {
    second = requestAnimationFrame(action);
  });
  return () => {
    cancelAnimationFrame(first);
    cancelAnimationFrame(second);
  };
}
